import { Injectable } from '@angular/core';
import { BehaviorSubject, map } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LoadingService {
  private isLoading = new BehaviorSubject<number>(0);
  isLoading$ = this.isLoading.asObservable().pipe(map((count) => count > 0));

  increment() {
    setTimeout(() => this.isLoading.next(this.isLoading.value + 1));
  }

  decrement() {
    setTimeout(() => this.isLoading.next(Math.max(0, this.isLoading.value - 1)));
  }

  setLoading(loading: number) {
    this.isLoading.next(loading);
  }
}
